module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "help"
  }, [_c('div', {
    staticClass: "sec"
  }, [_c('top', {
    attrs: {
      "title": '帮助中心'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "con",
    domProps: {
      "innerHTML": _vm._s(_vm.temp)
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-73245067"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/help/help.vue
// module id = 635
// module chunks = 31